import { useEffect, useRef, useState } from 'react'

import { EMPTY_OBJECT } from '../constants/common'
import {
  EVENT_NAME_MOUSE_ENTER,
  EVENT_NAME_MOUSE_LEAVE,
} from '../constants/event'

export function useMouseHover(props = EMPTY_OBJECT) {
  const { initRef = null } = props

  const [isHovered, setHover] = useState(false)

  const ref = useRef(initRef)

  function handleMouseEnter() {
    setHover(true)
  }

  function handleMouseLeave() {
    setHover(false)
  }

  useEffect(() => {
    const el = ref.current

    const mouseEnterHandler = props.onMouseEnter || handleMouseEnter
    const mouseLeaveHandler = props.onMouseLeave || handleMouseLeave

    if (el) {
      el.addEventListener(EVENT_NAME_MOUSE_ENTER, mouseEnterHandler)
      el.addEventListener(EVENT_NAME_MOUSE_LEAVE, mouseLeaveHandler)

      return function cleanup() {
        el.removeEventListener(EVENT_NAME_MOUSE_ENTER, mouseEnterHandler)
        el.removeEventListener(EVENT_NAME_MOUSE_LEAVE, mouseLeaveHandler)
      }
    }
  }, [])

  return [ref, isHovered]
}
